export class PipingLine {
  pipingLineId: string;
  lineNumber: string;
  description: string;
  drawingNumber: string;
  pipeSpecification: string;
  nominalSize: string;
  pipeSchedule: string;
  flangeRating: string;
  insulationType: string;
  tracingType: string;
  orgTreeNodeId: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.pipingLineId = data.pipingLineId;
    this.lineNumber = data.lineNumber;
    this.description = data.description;
    this.drawingNumber = data.drawingNumber;
    this.pipeSpecification = data.pipeSpecification;
    this.nominalSize = data.nominalSize;
    this.pipeSchedule = data.pipeSchedule;
    this.flangeRating = data.flangeRating;
    this.insulationType = data.insulationType;
    this.tracingType = data.tracingType;
    this.orgTreeNodeId = data.orgTreeNodeId;
  }
}
